module.exports = __webpack_public_path__ + "img/video-player.6cee0d2b.svg";